import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SITE_APPS, formatAppTitle, getSiteOrigin } from '../config/siteBranding';
import { storeAuthRedirect } from '../utils/paths';
import { setPageMeta, resetPageMeta } from '../utils/pageMeta';
import TrainingLanding from './TrainingLanding';
import TrainingSportHome from './TrainingSportHome';
import TrainingTracker from './TrainingTracker';
import TrainingTrackerShell from './TrainingTrackerShell';
import PublicTrainingChallenge from './PublicTrainingChallenge';

const ProtectedTrainingRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!isAuthenticated) {
    storeAuthRedirect(window.location.pathname + window.location.search);
    return <Navigate to="/login" replace />;
  }

  return children;
};

const TrainingApp = () => {
  const location = useLocation();

  useEffect(() => {
    // Sport and landing pages set their own meta; keep a default for tracker.
    if (location.pathname.includes('/tracker')) {
      setPageMeta({
        title: formatAppTitle(`${SITE_APPS.training.name} Tracker`),
        description: SITE_APPS.training.description,
        url: `${getSiteOrigin()}${location.pathname}`,
      });
      return () => resetPageMeta();
    }
    return undefined;
  }, [location.pathname]);

  return (
    <Routes>
      <Route index element={<TrainingLanding />} />
      <Route path="public/challenge/:token" element={<PublicTrainingChallenge />} />
      <Route
        path="soccer/tracker"
        element={
          <ProtectedTrainingRoute>
            <TrainingTrackerShell>
              <TrainingTracker />
            </TrainingTrackerShell>
          </ProtectedTrainingRoute>
        }
      />
      <Route path="cross-country" element={<Navigate to="/training/running" replace />} />
      <Route path="xc" element={<Navigate to="/training/running" replace />} />
      <Route path=":sportId" element={<TrainingSportHome />} />
      <Route path="*" element={<Navigate to="/training" replace />} />
    </Routes>
  );
};

export default TrainingApp;
